export default "__VITE_ASSET__LbwSJgIg__"